export default __webpack_public_path__ + "static/media/Image4.aacb434d.png";